<template>
<div>
   <div class="detailsTitle">
      <h4>消息详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <div class="contBox">
      <div class="title item">{{data.messageTitle}}</div>
      <div class="box item">
          <div style="margin-right:20px">消息类型：{{[ "公告", "私信"][data.messageType-1]}}</div>
          <div>发布时间：{{data.releaseTime|dateFormat}}</div>
      </div>
      <div v-html="data.messageContent"></div>
  </div>
  </div>
</template>

<script>
import { readMsg, receiveMsgNoReadSum } from '@/api/common'
export default {
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      data: {}

    }
  },
  created () {
    readMsg({ messageId: this.id, userType: 1 }).then(res => {
      receiveMsgNoReadSum({
        userType: 1
      }).then(res => {
        this.$emit('msgFn', res)
      })
      this.data = res
    })
  },
  methods: {

    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.contBox{
  width: 80%;
  margin: 0 auto;
  .title{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;

  }
  .item{
    text-align: center;
  }
  .box{
    display: flex;
    justify-content: center;
  }
}
</style>
